var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerBarBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 5.83325C3.5 5.35 3.85258 4.95825 4.2875 4.95825H23.7125C24.1474 4.95825 24.5 5.35 24.5 5.83325C24.5 6.3165 24.1474 6.70825 23.7125 6.70825H4.2875C3.85258 6.70825 3.5 6.3165 3.5 5.83325Z",
    fill: "#222729"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 14C3.5 13.5168 3.85258 13.125 4.2875 13.125H23.7125C24.1474 13.125 24.5 13.5168 24.5 14C24.5 14.4832 24.1474 14.875 23.7125 14.875H4.2875C3.85258 14.875 3.5 14.4832 3.5 14Z",
    fill: "#222729"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 22.1665C3.5 21.6833 3.85258 21.2915 4.2875 21.2915H23.7125C24.1474 21.2915 24.5 21.6833 24.5 22.1665C24.5 22.6498 24.1474 23.0415 23.7125 23.0415H4.2875C3.85258 23.0415 3.5 22.6498 3.5 22.1665Z",
    fill: "#222729"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerBarBlack);
export default __webpack_public_path__ + "static/media/hamburger-bar-black.e1d829f9a2d2be9f9697535efcc51f2c.svg";
export { ForwardRef as ReactComponent };